// „Überfällig" — die eine Regel, an einer Stelle (A37, #107).
//
// DER BEFUND, 29.08.: Eine Bestellung im Zustand „Abgeholt" trug das
// Merkzeichen „überfällig seit 28.08.". Sie ist abgeholt. Sie kann nicht
// überfällig sein.
//
// Es war EINE fehlende Bedingung an mehreren Stellen — überall wurde nur
// gerechnet, ob ein Datum vorbei ist, nie, ob der Vorgang noch läuft:
//   DashboardKarten.tsx   das Merkzeichen auf der Karte
//   DashboardTable.tsx    das Merkzeichen in der Tabelle
//   $bestellnr.tsx        dasselbe Merkzeichen in der Detailansicht
//   api/lib/dashboard.php Filter „Nur überfällig" und die Sortierung
//   api/bestellungen.php  der Zähler in der Fußzeile
//
// Die Daten waren die ganze Zeit da: `zustand.ist_endzustand` steht seit
// jeher in types/dashboard.ts. Es wurde nur nicht gelesen.
//
// DIESE DATEI UND DAS BACKEND MÜSSEN DASSELBE SAGEN. Sonst zeigt die
// Liste etwas anderes als der Zähler darüber — genau der Befund aus A20.
// Die SQL-Hälfte steht als DASH_UEBERFAELLIG_WHERE in lib/dashboard.php,
// und api/tests/run.php misst sie an echten Zeilen.

/**
 * Ist dieser Vorgang überfällig?
 *
 * @param istEndzustand    Läuft er noch? Ein abgeschlossener Vorgang ist
 *                         nie überfällig — egal, wie lange sein Termin
 *                         her ist.
 * @param tageUeberfaellig Tage SEIT dem zugesagten Termin. Positiv heißt
 *                         vorbei, `null` heißt: kein Termin zugesagt.
 *                         Der Termin von heute zählt noch nicht.
 */
export function istUeberfaellig(
  istEndzustand: boolean,
  tageUeberfaellig: number | null
): boolean {
  if (istEndzustand) return false;
  return tageUeberfaellig !== null && tageUeberfaellig > 0;
}

/**
 * Dasselbe für eine Dashboard-Zeile.
 *
 * Reiner Übersetzer: Der Server liefert `tage_bis_zugesagt`, und das
 * zählt in die andere Richtung — NEGATIV heißt vorbei. Diese Umdrehung
 * an drei Stellen von Hand zu machen ist genau die Sorte Kleinigkeit,
 * bei der eine Stelle irgendwann das Vorzeichen vergisst.
 *
 * Die Zahl kommt bewusst vom Server und wird nicht aus dem Datum neu
 * gerechnet: Der Filter und der Zähler rechnen mit UTC_DATE(), und drei
 * Meinungen darüber, wann „heute" anfängt, sind zwei zu viel.
 */
export function zeileIstUeberfaellig(b: {
  zustand: { ist_endzustand: boolean };
  tage_bis_zugesagt: number | null;
}): boolean {
  return istUeberfaellig(
    b.zustand.ist_endzustand,
    b.tage_bis_zugesagt === null ? null : -b.tage_bis_zugesagt
  );
}
